<template>
  <v-autocomplete
    v-model="internalValue"
    v-model:search="searchInput"
    v-bind="$attrs"
    autocomplete="off"
    class="app-select"
    @update:model-value="searchInput = ''"
  >
    <template v-if="$slots.item" #item="{ item, index, props }">
      <slot
        name="item"
        :item="item"
        :index="index"
        :props="props"
      />
    </template>
    <template v-if="$slots.selection" #selection="{ item, index }">
      <slot
        name="selection"
        :item="item"
        :index="index"
      />
    </template>
    <template v-if="$slots.chip" #chip="{ item, index, props }">
      <slot
        name="chip"
        :item="item"
        :index="index"
        :props="props"
      />
    </template>
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { debounce } from 'lodash-es';

import { Nullable } from '@/utils/types';

export default defineComponent({
  name: 'AppAutocomplete',

  props: {
    modelValue: {
      type: [String, Number, Object, Array],
      default: null,
    },
  },

  emits: ['update:modelValue', 'update:search-input-debounced'],

  // The search is reset to '' after a pick, never null: Vuetify 3 clears a
  // single-select model on blur while its search is null.
  data: (): { searchInput: Nullable<string> } => ({
    searchInput: null,
  }),

  computed: {
    internalValue: {
      get (): any {
        return this.modelValue;
      },
      set (value: any): void {
        this.$emit('update:modelValue', value);
      },
    },
  },

  watch: {
    searchInput (): void {
      this.updateSearchInputDebounced(this);
    },
  },

  methods: {
    updateSearchInputDebounced: debounce(function (vm: any) {
      vm.$emit('update:search-input-debounced', vm.searchInput);
    }, 500),
  }
});
</script>
